module.exports = __webpack_public_path__ + "img/gift3.bb7564a2.png";